"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _inlineVideo = _interopRequireDefault(require("../../../elements/other/inline-video"));
const MarqueeVideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MarqueeVideoContainer",
  class: "pl-m1jpz5b1"
});

/**
 * Marquee Video Component.
 * This component wraps the InlineVideo component for use in marquees.
 *
 * @param {Object} props React props
 * @param {String} props.introUrl Video URL
 * @param {String} props.introUrlWebm Video URL in WebM format
 * @param {String} props.introUrlLaptop Video URL for laptop
 * @param {String} props.introUrlLaptopWebm Video URL for laptop in WebM format
 * @param {String} props.thumbnailDesktop Thumbnail URL for desktop
 * @param {String} props.thumbnailMobile Thumbnail URL for mobile
 * @param {Element} props.videos React element with video props
 * @param {String} props.preload Preload setting for video
 * @returns {React.ReactElement} MarqueeVideo Component
 * @public
 */
function MarqueeVideo({
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  thumbnailDesktop,
  thumbnailMobile,
  videos,
  preload = 'auto'
}) {
  return /*#__PURE__*/_react.default.createElement(MarqueeVideoContainer, null, /*#__PURE__*/_react.default.createElement(_inlineVideo.default, {
    introUrl: introUrl,
    introUrlWebm: introUrlWebm,
    introUrlLaptop: introUrlLaptop,
    introUrlLaptopWebm: introUrlLaptopWebm,
    thumbnailDesktop: thumbnailDesktop,
    thumbnailMobile: thumbnailMobile,
    videos: videos,
    preload: preload,
    loop: false
  }));
}
var _default = exports.default = MarqueeVideo;
MarqueeVideo.propTypes = {
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  introUrlLaptop: _propTypes.default.string,
  introUrlLaptopWebm: _propTypes.default.string,
  thumbnailDesktop: _propTypes.default.string,
  thumbnailMobile: _propTypes.default.string,
  videos: _propTypes.default.element,
  preload: _propTypes.default.string
};